import axios from "../http";
let module = "/sysDataPermission";
function dataPermission(id){
	return axios.get(module + '/' + id);
}
export default {
	dataPermission
}